/* eslint-disable no-nested-ternary */
import React, { Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3CustomInput from '@Uilib/h3CustomInput';
import './style.scss';

const CustomFieldV3 = ({
  customFields, formSubmitted, customInputChange, disableCase, isHorizontalUi, inputClassName,
  labelClassName, containerClassName, wrapperClassName, errorClassName, isUpdate, match, isCarryForward,
}) => {
  const isDocumentInUpdateState = match.url.includes('/update') || (isUpdate === true);
  const isDocumentIsCarryForwarding = isCarryForward;
  // Helper function to determine if the input should be disabled
  const shouldDisableField = (customField) => (
    disableCase
    || (isDocumentInUpdateState && customField.isEditable === false)
    || (isDocumentIsCarryForwarding && customField.isCarryForward === false)
  );
  return (
    <Fragment>
      {customFields?.filter((item) => (item.visible && item.isActive && item?.fieldType?.toUpperCase() !== 'ATTACHMENT' && item?.fieldType?.toUpperCase() !== 'CHECKBOX' && item?.fieldType?.toUpperCase() !== 'TEXTAREA'))?.map((customField, index) => (
        <React.Fragment key={customField?.cfId}>
          <div key={customField?.cfId} className={wrapperClassName}>
            <H3CustomInput
              containerClassName={containerClassName}
              labelClassName={labelClassName}
              inputClassName={inputClassName}
              inputErrorClassName={errorClassName}
              type={customField?.fieldType?.toUpperCase()}
              required={customField?.isRequired}
              label={customField?.fieldName}
              options={customField?.defaultData?.length ? customField?.defaultData : []}
              placeholder={customField?.placeholder}
              onChange={(value) => customInputChange(value, customField?.cfId)}
              value={customField?.fieldValue}
              showError={formSubmitted && customField?.isRequired && !customField?.fieldValue}
              disabled={shouldDisableField(customField)}
              height={28}
            />
          </div>
        </React.Fragment>
      ))}
      {customFields?.filter((item) => (item.visible && item.isActive && (item?.fieldType?.toUpperCase() === 'ATTACHMENT' || item?.fieldType?.toUpperCase() === 'CHECKBOX' || item?.fieldType?.toUpperCase() === 'TEXTAREA')))?.map((customField, index) => (
        <Fragment key={customField?.cfId}>
          <div className="ant-col-md-24">
            <H3CustomInput
              containerClassName={containerClassName}
              labelClassName={labelClassName}
              inputClassName={inputClassName}
              inputErrorClassName={errorClassName}
              type={customField?.fieldType?.toUpperCase()}
              required={customField?.isRequired}
              label={customField?.fieldName}
              options={customField?.defaultData?.length ? customField?.defaultData : []}
              placeholder={customField?.placeholder}
              onChange={(value) => customInputChange(value, customField?.cfId)}
              value={customField?.fieldValue}
              showError={(formSubmitted && customField?.isRequired && !customField?.fieldValue) || (formSubmitted && customField?.isRequired && customField?.fieldType?.toUpperCase() === 'ATTACHMENT' && customField?.fieldValue?.length === 0)}
              disabled={shouldDisableField(customField)}
              isHorizontalUi={isHorizontalUi}
            />
          </div>
        </Fragment>
      ))}
    </Fragment>
  );
};
const mapStateToProps = () => ({

});

const mapDispatchToProps = (dispatch) => ({
});

CustomFieldV3.propTypes = {
  customFields: PropTypes.any,
  formSubmitted: PropTypes.any,
  customInputChange: PropTypes.any,
  disableCase: PropTypes.any,
  isHorizontalUi: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.any,
  containerClassName: PropTypes.any,
  wrapperClassName: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomFieldV3));
